import React from 'react';
import Link from 'next/link';

// Importing images from assets/img/casestudy2Articles/
import art1 from '../../assets/img/casestudy2Articles/1.png';
import art2 from '../../assets/img/casestudy2Articles/2.png';
import art3 from '../../assets/img/casestudy2Articles/3.png';

const CaseStudy2Articles = () => {
    const articles = [
        {
            id: 1,
            img: art1,
            title: "What is the role of Revit 3D modelling in construction?",
            desc: "The visualisation of a complete architectural project might be a difficult task for anyone who doesn't have much of an ...",
            link: "#"
        },
        {
            id: 2,
            img: art2,
            title: "Benefits of BIM in Construction",
            desc: "The advantages of BIM design are multiple, for all stakeholders and at all stages of a project. BIM is changing the way contractors, architects, and engineers work ...",
            link: "#"
        },
        {
            id: 3,
            img: art3,
            title: "Importance of BIM in the AEC industry in 2020 and beyond",
            desc: "Building information modeling (BIM) is some of the most powerful proptech out there now. It is certainly transforming ...",
            link: "#"
        }
    ];

    return (
        <section className="cs-articles-section">
            <div className="cs-articles-container">
                <div className="cs-articles-header">
                    <h2 className="section-title">
                        <span className="text-primary">Related</span> Articles
                    </h2>
                    <p className="section-subtitle">
                        Check out our articles on BIM modeling and its importance for construction.
                    </p>
                </div>

                <div className="cs-articles-grid">
                    {articles.map((article) => (
                        <div key={article.id} className="cs-article-card">
                            <div className="cs-article-img">
                                <img src={article.img.src || article.img} alt={article.title} />
                            </div>
                            <div className="cs-article-info">
                                <h3 className="cs-article-title">{article.title}</h3>
                                <p className="cs-article-desc">{article.desc}</p>
                                <Link href={article.link} className="cs-article-btn">
                                    Read More <span>→</span>
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default CaseStudy2Articles;
